import { createRef } from 'react'

export default class PrivacyTermsCheckbox extends React.Component {
  constructor (props) {
    super(props)
    this.checkboxRef = createRef(null)
  }

  render () {
    const text = this.props.text ? this.props.text : I18n.t('layouts.accept_privacy_terms', { href: this.props.href })
    return (
      <label className='checkbox' htmlFor='terms'>
        <input
          type='checkbox'
          ref={this.checkboxRef}
          name='terms'
          id='terms'
          onChange={this.props.onAccept || this.defaultAction.bind(this)}
          checked={this.props.checked}
        />
        <span dangerouslySetInnerHTML={{ __html: text }} />
        {this.props.required && <abbr title='required' style={{ marginLeft: 3 }}>*</abbr>}
        <span className='box' />
      </label>
    )
  }

  defaultAction (e) {
    const $button = this.props.target ? $(this.props.target) : $(this.checkboxRef.current.form).find('input[type="submit"]')
    $button.prop('disabled', !e.target.checked)
  }
}

PrivacyTermsCheckbox.propTypes = {
  href: PropTypes.string,
  checked: PropTypes.bool,
  text: PropTypes.string,
  target: PropTypes.string, // target for defaultAction
  onAccept: PropTypes.func, // custom action
  required: PropTypes.bool
}
